import "core-js/modules/es.array.push.js";
import imglocation from "../assets/imgs/location.png";
import AMapLoader from "@amap/amap-jsapi-loader";
import { reactive, onMounted, getCurrentInstance } from "vue";
// import { socket } from "../util/websocket";
import { useRouter, useRoute } from "vue-router";
import { city } from "../util/city";
window._AMapSecurityConfig = {
  securityJsCode: "d0c579bd371cc891004a21216adac5b9"
};
export default {
  name: "Map",
  props: ["addressType", "sort"],
  setup(props, ctx) {
    const router = useRouter();
    const route = useRoute();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    let data = reactive({
      city: "",
      province: "",
      district: "",
      loading: false,
      isShowTips: true,
      AMap: null,
      markers: [],
      // 渲染的车辆marker集合
      amap: null,
      geocoder: null,
      city,
      addressValue: "",
      cascaderValue: [],
      cascaderProps: {
        label: "value"
      },
      list: [],
      currentUserPosition: null
    });
    onMounted(() => {
      initMap();
      //  socket.send({cmd: 2,extras:{id:1}});
    });

    //初始化地图
    const initMap = () => {
      AMapLoader.load({
        key: "dbf41f7626575035500077916f66b1e3",
        version: "2.0",
        plugins: ["AMap.MoveAnimation", "AMap.MapType", "AMap.Geocoder", "AMap.Marker", "AMap.PlaceSearch", "GeometryUtil"]
      }).then(AMap => {
        data.amap = new AMap.Map("amap", {
          viewMode: "3D",
          terrain: true,
          zoom: 16,
          center: [116.397428, 39.90923]
        });
        //监听地图加载完毕
        data.amap.on("complete", async () => {
          data.AMap = AMap;
          await panToUserPosition();
          var type = new AMap.MapType({
            showTraffic: true
          });
          data.amap.addControl(type);
          // 点击地图触发事件
          data.amap.on("click", e => {
            const {
              lng,
              lat
            } = e.lnglat;
            handleGeocoder(lng, lat);
          });
        });
      }).catch(e => {});
    };

    //地图移至用户位置
    const panToUserPosition = () => {
      AMap.plugin("AMap.Geolocation", function () {
        var _geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          timeout: 0,
          buttonPosition: "RB",
          buttonOffset: new AMap.Pixel(10, 20),
          zoomToAccuracy: true,
          needAddress: true
        });
        _geolocation.getCityInfo((status, result) => {
          if (status == "complete") {
            data.amap.panTo(result.position, 600);
            handleGeocoder(result.position[0], result.position[1]);
          }
        });
      });
    };

    //逆地址解析
    const handleGeocoder = (lng, lat) => {
      var geocoder = new data.AMap.Geocoder({
        extensions: "010"
      });
      geocoder.getAddress([lng, lat], function (s, res) {
        if (s === "complete" && res.info === "OK") {
          const {
            province,
            city,
            district,
            adcode
          } = res.regeocode.addressComponent;
          data.currentUserPosition = {
            lng,
            lat,
            province,
            city,
            district,
            address: res.regeocode.formattedAddress,
            countrySubdivisionCode: adcode
          };
          data.cascaderValue = [province, city, district];
          createMarker(lng, lat);
        }
      });
    };

    //创建标记
    const createMarker = (lon, lat) => {
      const markerContent = `<img style=" width:2.5vw ;
  height: 2.5vw;" src="${imglocation}">`;
      const marker = new data.AMap.Marker({
        position: [lon, lat],
        content: markerContent,
        anchor: "center",
        map: data.amap
      });
      data.markers.forEach(marker => marker.setMap(null));
      data.markers.push(marker);
    };

    //搜索
    const searchAddress = () => {
      if (!data.addressValue) return data.list = [];
      data.loading = true;
      const params = {
        city: data.cascaderValue[1] || "",
        type: "",
        pageSize: 100,
        pageIndex: 1,
        extensions: "all"
      };
      var MSearch = new data.AMap.PlaceSearch(params);
      MSearch.search(data.addressValue, (status, res) => {
        if (status == "complete" && res?.info == "OK") {
          data.list = res?.poiList?.pois || [];
          data.loading = false;
        }
      });
    };

    //清空搜索
    const clearAddressValue = () => {
      data.addressValue = "";
      data.list = [];
    };

    //查看地图位置
    const toViewMapLocation = index => {
      const {
        location: {
          lng,
          lat
        },
        pname,
        cityname,
        adname,
        name,
        address
      } = data.list[index];
      data.currentUserPosition = {
        lng,
        lat,
        province: pname,
        city: cityname,
        district: adname,
        address: name,
        desc: pname + cityname + adname + address
      };
      createMarker(lng, lat);
      data.amap.panTo([lng, lat], 0);
    };

    //选择地区
    const handleCity = value => data.cascaderValue = value;

    //关闭提示
    const closeTips = () => data.isShowTips = false;

    //返回
    const back = () => {
      route.params.user = "123";
      router.back(-1);
    };
    const sendCurrentAddress = () => {
      const {
        addressType,
        sort
      } = props;
      const {
        address,
        city,
        district,
        lat,
        lng,
        province,
        countrySubdivisionCode
      } = data.currentUserPosition;
      const params = {
        address,
        addressType,
        city,
        district,
        lat,
        lon: lng,
        province,
        sort,
        countrySubdivisionCode
      };
      ctx.emit("sendCurrentAddress", params);
    };
    const selectListAddress = index => {
      const {
        pname,
        cityname,
        adname,
        location: {
          lat,
          lng
        },
        name,
        address,
        adcode
      } = data.list[index];
      const {
        addressType,
        sort
      } = props;
      const params = {
        address: pname + cityname + adname + address + name,
        addressType,
        city: cityname,
        district: adname,
        lat,
        lon: lng,
        province: pname,
        sort,
        countrySubdivisionCode: adcode
      };
      ctx.emit("sendCurrentAddress", params);
    };
    return {
      data,
      props,
      panToUserPosition,
      handleCity,
      searchAddress,
      closeTips,
      back,
      clearAddressValue,
      sendCurrentAddress,
      toViewMapLocation,
      selectListAddress
    };
  }
};